import React from 'react';
import PublicLayout from '../components/PublicLayout';
import { useTranslation } from 'react-i18next';
import { CookiesSEO } from '../components/SEO';
import { FloatingShapes } from '../components/icons/FeatureIcons';
import { Shield, BarChart3, Settings } from 'lucide-react';

const Cookies = () => {
  const { t } = useTranslation();
  const items = [
    {
      title: t('pages.cookies.essentialTitle'),
      body: t('pages.cookies.essentialDesc'),
      Icon: Shield,
      gradient: 'from-green-500 to-emerald-600'
    },
    {
      title: t('pages.cookies.performanceTitle'),
      body: t('pages.cookies.performanceDesc'),
      Icon: BarChart3,
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      title: t('pages.cookies.preferencesTitle'),
      body: t('pages.cookies.preferencesDesc'),
      Icon: Settings,
      gradient: 'from-purple-500 to-purple-600'
    }
  ];

  return (
    <PublicLayout>
      <CookiesSEO />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-purple-600 to-indigo-700 py-20 overflow-hidden">
        <FloatingShapes />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <p className="text-sm font-semibold text-purple-200 uppercase tracking-wide mb-4">{t('footer.legal')}</p>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white mb-6">{t('pages.cookies.title')}</h1>
          <p className="text-xl text-purple-100 max-w-2xl mx-auto">{t('pages.cookies.subtitle')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 -mt-10 relative z-10">
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.title} className="p-6 border border-gray-100 rounded-2xl shadow-lg bg-white hover:shadow-xl transition-shadow">
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center flex-shrink-0 shadow-lg`}>
                  <item.Icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">{item.title}</h2>
                  <p className="text-sm text-gray-700 leading-relaxed">{item.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};

export default Cookies;
